import { render, staticRenderFns } from "./bankCreate.vue?vue&type=template&id=568916c8&scoped=true&lang=html&"
import script from "./bankCreate.vue?vue&type=script&lang=js&"
export * from "./bankCreate.vue?vue&type=script&lang=js&"
import style0 from "./bankCreate.vue?vue&type=style&index=0&id=568916c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568916c8",
  null
  
)

export default component.exports